module.exports = __webpack_public_path__ + "img/ext13.5f2782b4.jpg";